<template>
    <el-tag :type="type">
       {{ name }}
    </el-tag>
</template>
<script>
// 标签
// 标签类型
const TagMap = {
    '60': {
        text: '通知結束',
        type: 'success'
    },
    '20': {
        text: '已抽取',
        type: 'success'
    },
    '30': {
        text: '等待通知',
        type: 'success'
    },
    '40': {
        text: '通知中',
        type: 'warning'
    },
    '15': {
        text: '开始抽取',
        type: 'warning'
    },
    '35': {
        text: '获取成功等待通知',
        type: 'warning'
    },
    '5': {
        text: '待审核',
        type: 'danger'
    },

}
export default {
    props: {
        status: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    },
    computed: {
        type() {
            return TagMap[this.status].type || 'danger'
        },
        name() {
            return TagMap[this.status].text || this.text
        }
    }
}
</script>